import * as React from 'react';
import { Icon } from '../../../components/icons/Icon';
import { Button } from '../../../components/Button';

export interface EditableFieldActionsProps {
  saving: boolean;
  saveLabel: string;
  cancelLabel: string;
  onSave: () => void;
  onCancel: () => void;
}

/**
 * Floating save/cancel toolbar shown below the editor input.
 *
 * Absolutely positioned so it never shifts the width of the field or overlaps
 * neighbouring layout cells. `onMouseDown` (not `onClick`) is used to commit
 * before the input loses focus.
 */
export function EditableFieldActions({
  saving,
  saveLabel,
  cancelLabel,
  onSave,
  onCancel
}: EditableFieldActionsProps) {
  return (
    <div className='absolute right-0 top-[calc(100%+3px)] z-20 flex gap-xs rounded-md border border-border-base bg-background-input p-2xs shadow-md'>
      <Button
        size='sm'
        onMouseDown={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.preventDefault(); // Prevent focus loss
          onSave();
        }}
        disabled={saving}
        aria-label={saveLabel}
        className='h-7 px-sm'
        tabIndex={-1}
      >
        <Icon name='check' className='h-3.5 w-3.5' />
      </Button>
      <Button
        size='sm'
        variant='ghost'
        onMouseDown={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.preventDefault(); // Prevent focus loss
          onCancel();
        }}
        disabled={saving}
        aria-label={cancelLabel}
        className='h-7 px-sm'
        tabIndex={-1}
      >
        <Icon name='xmark' className='h-3.5 w-3.5' />
      </Button>
    </div>
  );
}

EditableFieldActions.displayName = 'EditableFieldActions';
